import type { SpecsAutoFormFieldMetadataMap } from "../autoFormMetadata";
import { ObservableModelNode } from "../observable";
import {
  cloneValue,
  expectObject,
  readObjectArray,
  readString,
  splitKnown,
} from "../utils";
import { ProductVersionFactoryPricingBracketModel } from "./ProductVersionFactoryPricingBracketModel";
import { ProductVersionFactoryPricingExtraColorModel } from "./ProductVersionFactoryPricingExtraColorModel";
import { ProductVersionFactoryPricingLargeSizeModel } from "./ProductVersionFactoryPricingLargeSizeModel";

export class ProductVersionFactoryPricingModel extends ObservableModelNode {
  static autoFormFields: SpecsAutoFormFieldMetadataMap = {
    overPolicy: { label: "Over Policy", fieldType: "text" },
    extra: { label: "Extra JSON", fieldType: "json", minRows: 4 },
  };

  overPolicy!: string;
  extraColorPrice!: ProductVersionFactoryPricingExtraColorModel[];
  largeSizeSurcharge!: ProductVersionFactoryPricingLargeSizeModel[];
  priceBrackets!: ProductVersionFactoryPricingBracketModel[];
  extra!: Record<string, unknown>;

  constructor() {
    super();
    this.defineObservableValue("overPolicy", "");
    this.defineObservableValue("extraColorPrice", []);
    this.defineObservableValue("largeSizeSurcharge", []);
    this.defineObservableValue("priceBrackets", []);
    this.defineObservableValue("extra", {});
  }

  restore(snapshot: unknown) {
    const source = expectObject(snapshot, "product factory pricing");
    this.overPolicy = readString(source, "overPolicy");
    this.extraColorPrice = readObjectArray(source, "extraColorPrice").map(
      (entry) =>
        new ProductVersionFactoryPricingExtraColorModel().restore(entry)
    );
    this.largeSizeSurcharge = readObjectArray(source, "largeSizeSurcharge").map(
      (entry) => new ProductVersionFactoryPricingLargeSizeModel().restore(entry)
    );
    this.priceBrackets = readObjectArray(source, "priceBrackets").map((entry) =>
      new ProductVersionFactoryPricingBracketModel().restore(entry)
    );
    this.extra = splitKnown(source, [
      "overPolicy",
      "extraColorPrice",
      "largeSizeSurcharge",
      "priceBrackets",
    ]);
    return this;
  }

  save() {
    return {
      ...cloneValue(this.extra),
      ...(this.overPolicy ? { overPolicy: this.overPolicy } : {}),
      ...(this.extraColorPrice.length > 0
        ? { extraColorPrice: this.extraColorPrice.map((entry) => entry.save()) }
        : {}),
      ...(this.largeSizeSurcharge.length > 0
        ? {
            largeSizeSurcharge: this.largeSizeSurcharge.map((entry) =>
              entry.save()
            ),
          }
        : {}),
      ...(this.priceBrackets.length > 0
        ? { priceBrackets: this.priceBrackets.map((entry) => entry.save()) }
        : {}),
    };
  }
}
